// import React, { useContext } from "react";
// import { LanguageContext } from "../context/LanguageContext";
// import en from "../data/data.json";
// import cs from "../data/data_cs.json";

// export const Header = (props) => {
//   const { language } = useContext(LanguageContext);
//   const translations = language === 'cs' ? cs : en;

//   return (
//     <header id="header">
//       <div className="intro">
//         <div className="overlay">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-8 col-md-offset-2 intro-text">
//                 <h1>
//                   {/* {props.data ? props.data.title : "Loading"} */}
//                   {translations.Header.title}
//                   <span></span>
//                 </h1>
//                 {/* <p>{props.data ? props.data.paragraph : "Loading"}</p> */}
//                  <p>{translations.Header.paragraph}</p>
//                 {/* Remove or comment out the Features link */}
//                 {/* <a
//                   href="#features"
//                   className="btn btn-custom btn-lg page-scroll"
//                 >
//                   Learn More
//                 </a>{" "} */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };



import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import en from "../data/data.json";
import cs from "../data/data_cs.json";

export const Header = () => {
  const { language } = useContext(LanguageContext);
  const translations = language === "cs" ? cs : en;

  const paragraph = translations.Header?.paragraph || "";
  const parts = paragraph.split("\n\n");
  // choose the second paragraph as the "lead" if present (this contains "Proměňujeme..." / "Turning...")
  const sub = parts[1] ? parts[1].replace(/^"+|"+$/g, "") : parts[0];
  const lead = parts[1] ? parts[0] : "";

  return (
    <header
      id="header"
      className="intro-header"
      style={{ backgroundImage: "url('/img/intro-bg.jpg')" }}
    >
      <div className="overlay" />
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 intro-text">
            <h1 className="header-title">
              {lead ? <span className="intro-lead">{lead}</span> : null}
              <br/>
              {sub ? <span className="intro-sub">{sub}</span> : null}
            </h1>
          </div>
        </div>
      </div>
    </header>
  );
};
